module.exports = __webpack_public_path__ + "img/a11y-onionskin_en.33b5325.jpg";